import { themed } from '@indeed/ifl-css';

const CARD_SECTION_DEFAULT_TAG = "div";
const CardSection = /*#__PURE__*/themed(CARD_SECTION_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e1gufzzf0"
} : {
  styleProps: [],
  target: "e1gufzzf0",
  label: "CardSection"
})(() => ({
  paddingInlineStart: 4,
  paddingInlineEnd: 4,
  paddingBlockEnd: 4,
  paddingBlockStart: 4,
  ":first-of-type:not(:only-of-type)": {
    paddingBlockEnd: 0
    // Remove bottom padding for the first section (header) unless it is the only section
  },
  ":not(:first-of-type, :nth-of-type(2))": {
    paddingBlockStart: 0
    // Remove top padding for all sections >= 3 (anything after the body)
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRTZWN0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZMkIiLCJmaWxlIjoiQ2FyZFNlY3Rpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5pbXBvcnQgKiBhcyBQb2x5bW9ycGhpYyBmcm9tIFwiLi4vLi4vdHlwZXMvcG9seW1vcnBoaWNcIjtcblxuZXhwb3J0IGNvbnN0IENBUkRfU0VDVElPTl9ERUZBVUxUX1RBRyA9IFwiZGl2XCI7XG5cbmV4cG9ydCB0eXBlIENhcmRTZWN0aW9uID0gU3R5bGVQcm9wcztcbmV4cG9ydCB0eXBlIENhcmRTZWN0aW9uQ29tcG9uZW50ID0gUG9seW1vcnBoaWMuQ29tcG9uZW50PFxuICB0eXBlb2YgQ0FSRF9TRUNUSU9OX0RFRkFVTFRfVEFHLFxuICBDYXJkU2VjdGlvblxuPjtcblxuZXhwb3J0IGNvbnN0IENhcmRTZWN0aW9uID0gdGhlbWVkKENBUkRfU0VDVElPTl9ERUZBVUxUX1RBRywge1xuICBzdHlsZVByb3BzOiBbXVxufSkoKCkgPT4gKHtcbiAgcGFkZGluZ0lubGluZVN0YXJ0OiA0LFxuICBwYWRkaW5nSW5saW5lRW5kOiA0LFxuICBwYWRkaW5nQmxvY2tFbmQ6IDQsXG4gIHBhZGRpbmdCbG9ja1N0YXJ0OiA0LFxuICBcIjpmaXJzdC1vZi10eXBlOm5vdCg6b25seS1vZi10eXBlKVwiOiB7XG4gICAgcGFkZGluZ0Jsb2NrRW5kOiAwXG4gICAgLy8gUmVtb3ZlIGJvdHRvbSBwYWRkaW5nIGZvciB0aGUgZmlyc3Qgc2VjdGlvbiAoaGVhZGVyKSB1bmxlc3MgaXQgaXMgdGhlIG9ubHkgc2VjdGlvblxuICB9LFxuICBcIjpub3QoOmZpcnN0LW9mLXR5cGUsIDpudGgtb2YtdHlwZSgyKSlcIjoge1xuICAgIHBhZGRpbmdCbG9ja1N0YXJ0OiAwXG4gICAgLy8gUmVtb3ZlIHRvcCBwYWRkaW5nIGZvciBhbGwgc2VjdGlvbnMgPj0gMyAoYW55dGhpbmcgYWZ0ZXIgdGhlIGJvZHkpXG4gIH1cbn0pKSBhcyBDYXJkU2VjdGlvbkNvbXBvbmVudDtcblxuQ2FyZFNlY3Rpb24uZGlzcGxheU5hbWUgPSBcIkNhcmRTZWN0aW9uXCI7XG4iXX0= */");
CardSection.displayName = "CardSection";

export { CARD_SECTION_DEFAULT_TAG, CardSection };
